import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  rows: {
    id: number;
    pedido: number;
    venda_uuid: number;
    vendedor: number;
    data_venda: string;
    razao_nome: string;
    email: string;
    telefone: string;
    celular: string;
  }[];
}

// tipagem do que o hook retorna
type ICertificadosReponse = IResponseData['rows'];

async function getCertificados(search: string): Promise<ICertificadosReponse> {
  const response = await backend.get<IResponseData>('/certificados', {
    params: {
      search,
    },
  });
  return response.data.rows;
}

export function useCertificados(search: string) {
  return useQuery(['certificados', search], () => getCertificados(search), {
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 5,
    // refetchOnWindowFocus: false,
  });
}
